import { render, staticRenderFns } from "./ContactMobile.vue?vue&type=template&id=28df72b4&"
import script from "./ContactMobile.vue?vue&type=script&lang=ts&"
export * from "./ContactMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports